import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PackMenuItem } from '../model/pack-menu-item';

@Component({
  selector: 'ad-section-pack',
  templateUrl: './pack.component.html',
  styleUrls: ['./pack.component.css'],
})
export class PackComponent implements OnInit {
  @Input() packs: PackMenuItem[];
  @Output() OnItemClick: EventEmitter<any> = new EventEmitter();
  constructor() {}

  ngOnInit() {
  }

  itemClick(event) {
    this.OnItemClick.emit(event);
  }
}
